/* Fidello: verwachte levering in de webshop, per leverancier en land, in de taal van de bezoeker.
 * Bron = Fidello Verzending (/publiek/levertijden), die het aan de Supplier Hub vraagt: dezelfde bron als de kassa.
 * Vervangt alleen de tekst van bestaande elementen (zelfde plek, kleur en grootte):
 *   [data-fidello-lever="Hofman"]   korte tekst op productkaart/productpagina: laatste bezorgdag van die leverancier
 *                                      in dit land ("Morgen bezorgd", "Uiterlijk woensdag bezorgd")
 *   ul.l4us li met een tijd ("17:30")  regel onder de knop (leverancier van het product op die pagina):
 *                                      "Op werkdagen vóór 13:00 besteld = dezelfde dag verzonden" (besteltijd van de leverancier).
 *                                      De USP-balk bovenaan (header) blijft ongemoeid (vaste teksten van het thema).
 * Lukt het ophalen niet, dan blijft de tekst van het thema staan.
 * Bron in de repo FidelloNL/fidello-verzending: thema/assets/fidello-levertijd.js */
(function () {
  var ADRES = 'https://fidello-verzending.klantenservice-a34.workers.dev/publiek/levertijden';

  var DAGEN = {
    nl: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
    en: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    de: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    fr: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
    sv: ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag'],
    da: ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag'],
    fi: ['sunnuntai', 'maanantai', 'tiistai', 'keskiviikko', 'torstai', 'perjantai', 'lauantai'],
    pl: ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota'],
    pt: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado']
  };
  var VANDAAG = { nl: 'vandaag', en: 'today', de: 'heute', fr: "aujourd'hui", sv: 'idag', da: 'i dag', fi: 'tänään', pl: 'dzisiaj', pt: 'hoje' };
  var MORGEN = { nl: 'morgen', en: 'tomorrow', de: 'morgen', fr: 'demain', sv: 'imorgon', da: 'i morgen', fi: 'huomenna', pl: 'jutro', pt: 'amanhã' };
  var OVERMORGEN = { nl: 'overmorgen', de: 'übermorgen' };
  var VOLGENDE = {
    nl: function (d) { return 'volgende week ' + d; }, de: function (d) { return 'nächste Woche ' + d; },
    fr: function (d) { return d + ' prochain'; }, en: function (d) { return 'next ' + d; },
    sv: function (d) { return 'nästa ' + d; }, da: function (d) { return 'næste ' + d; },
    fi: function (d) { return 'ensi viikon ' + d; }, pl: function (d) { return d + ' (za tydzień)'; },
    pt: function (d) { return d + ' da próxima semana'; }
  };
  // Bereik (bijv. België 1–2 dagen): "Uiterlijk woensdag bezorgd" (het kan dus ook sneller).
  var UITERLIJK = {
    nl: function (d) { return 'Uiterlijk ' + d + ' bezorgd'; }, de: function (d) { return 'Spätestens ' + d + ' geliefert'; },
    fr: function (d) { return 'Livré au plus tard ' + d; }, en: function (d) { return 'Delivered by ' + d; },
    sv: function (d) { return 'Levereras senast ' + d; }, da: function (d) { return 'Leveres senest ' + d; },
    fi: function (d) { return 'Toimitus viimeistään: ' + d; }, pl: function (d) { return 'Dostawa najpóźniej: ' + d; },
    pt: function (d) { return 'Entrega até: ' + d; }
  };
  // Korte tekst (productkaart / productpagina), zoals het thema nu al toont.
  var KORT = {
    nl: function (d) { return d + ' bezorgd'; }, de: function (d) { return d + ' geliefert'; },
    fr: function (d) { return 'Livré ' + d; }, en: function (d) { return 'Delivered ' + d; },
    sv: function (d) { return 'Levereras ' + d; }, da: function (d) { return 'Leveres ' + d; },
    fi: function (d) { return 'Toimitus: ' + d; }, pl: function (d) { return 'Dostawa: ' + d; },
    pt: function (d) { return 'Entrega: ' + d; }
  };
  // Regel onder de knop: de vaste besteltijd van de leverancier van dit product.
  var BESTEL = {
    nl: function (t) { return 'Op werkdagen vóór ' + t + ' besteld = dezelfde dag verzonden'; },
    de: function (t) { return 'Werktags vor ' + t + ' bestellt = am selben Tag versendet'; },
    fr: function (t) { return 'Commandé avant ' + t + ' un jour ouvré = expédié le jour même'; },
    en: function (t) { return 'Order before ' + t + ' on weekdays = shipped the same day'; },
    sv: function (t) { return 'Beställ före ' + t + ' på vardagar = skickas samma dag'; },
    da: function (t) { return 'Bestil før ' + t + ' på hverdage = sendes samme dag'; },
    fi: function (t) { return 'Tilaa arkisin ennen klo ' + t + ' = lähetetään samana päivänä'; },
    pl: function (t) { return 'Zamów w dni robocze przed ' + t + ' = wysyłka tego samego dnia'; },
    pt: function (t) { return 'Encomende em dias úteis antes das ' + t + ' = enviado no mesmo dia'; }
  };

  function taalVan(t) { t = String(t || 'nl').slice(0, 2).toLowerCase(); return KORT[t] ? t : 'en'; }
  function dagenTussen(a, b) { return Math.round((Date.parse(b + 'T12:00:00Z') - Date.parse(a + 'T12:00:00Z')) / 86400000); }
  function hoofdletter(s) { return s.charAt(0).toUpperCase() + s.slice(1); }
  function dagnaam(d, vandaag, taal, bereik) {
    var n = dagenTussen(vandaag, d);
    if (n === 0) return VANDAAG[taal];
    if (n === 1) return MORGEN[taal];
    if (n === 2 && OVERMORGEN[taal] && !bereik) return OVERMORGEN[taal];
    // Nooit een datum, altijd een dagnaam; een week of verder: "volgende week maandag" (anders lijkt het vandaag).
    var naam = DAGEN[taal][new Date(d + 'T12:00:00Z').getUTCDay()];
    return n < 7 ? naam : VOLGENDE[taal](naam);
  }
  // Productkaart en productpagina: de laatste bezorgdag van deze leverancier in dit land: "Morgen bezorgd" (vaste dag)
  // of bij een bereik "Uiterlijk woensdag bezorgd" (België, 1–2 dagen; altijd de dagnaam, niet "overmorgen").
  function kort(l, taal) {
    var max = l.bezorg_max || l.bezorg_min;
    if (max !== l.bezorg_min) return hoofdletter(UITERLIJK[taal](dagnaam(max, l.vandaag, taal, true)));
    return hoofdletter(KORT[taal](dagnaam(max, l.vandaag, taal, false)));
  }
  // Regel onder de knop: "Op werkdagen vóór 13:00 besteld = dezelfde dag verzonden" met de besteltijd van de leverancier
  // van dit product. null = niet aanraken (de Supplier Hub geeft (nog) geen besteltijd mee).
  function usp(l, taal) {
    var t = l.besteltijd_leverancier;
    return t ? BESTEL[taal](t) : null;
  }

  // Bestaande USP-regel met een besteltijd ("… 17:30 …") in de lijst ul.l4us onder de knop (productpagina).
  // Herkend aan de tijd in de tekst, zodat die bestanden niet hoeven te wijzigen.
  var TIJD = /\b\d{1,2}[:.]\d{2}\b/;
  function vulUsp(per, taal, wortel) {
    (wortel || document).querySelectorAll('ul.l4us li').forEach(function (li) {
      if (!li.hasAttribute('data-fidello-orig')) {
        if (!TIJD.test(li.textContent)) return;
        li.setAttribute('data-fidello-orig', '1');
      }
      // De USP-balk bovenaan (header) blijft van het thema: daar staan vaste teksten.
      if (li.closest('header, [id*="header"]')) return;
      var sectie = li.closest('[id^="shopify-section"]') || document;
      var bron = sectie.querySelector('[data-fidello-lever]');
      var l = bron && per[bron.getAttribute('data-fidello-lever')];
      var t = l && l.bezorg_min && usp(l, taal);
      if (!t) return;
      // De tekst zit in de diepste <span> (header) of direct in de <li> (productpagina); iconen blijven staan.
      var doel = li.querySelector('span span') || li.querySelector('span') || li;
      // Met een icoon ernaast: de tekst in een eigen <span> zetten, zodat ook een latere ronde het icoon laat staan.
      if (doel === li && li.querySelector('i, svg, img')) {
        var eigen = li.querySelector('span[data-fidello-usp]');
        if (!eigen) {
          var tekstknoop = Array.prototype.filter.call(li.childNodes, function (n) { return n.nodeType === 3 && TIJD.test(n.nodeValue); })[0];
          if (!tekstknoop) return;
          eigen = document.createElement('span');
          eigen.setAttribute('data-fidello-usp', '');
          li.replaceChild(eigen, tekstknoop);
        }
        eigen.textContent = ' ' + t;
        return;
      }
      doel.textContent = t;
    });
  }

  function vul(data, taal, wortel) {
    var per = {};
    (data.leveranciers || []).forEach(function (l) { if (l.tag && l.bezorg_min) per[l.tag] = l; });
    (wortel || document).querySelectorAll('[data-fidello-lever]').forEach(function (el) {
      var l = per[el.getAttribute('data-fidello-lever')];
      if (l) el.textContent = kort(l, taal);
    });
    vulUsp(per, taal, wortel);
  }

  var api = { kort: kort, usp: usp, vul: vul, taalVan: taalVan };
  if (typeof module !== 'undefined') { module.exports = api; return; }
  window.FidelloLevertijd = api;

  var land = (window.Shopify && window.Shopify.country) || '';
  var taal = taalVan((window.Shopify && window.Shopify.locale) || document.documentElement.lang);
  if (!/^[A-Z]{2}$/.test(land) || !document.querySelector('[data-fidello-lever], ul.l4us li')) return;

  function haal() {
    var sleutel = 'fidello-levertijd-' + land;
    try {
      var b = JSON.parse(sessionStorage.getItem(sleutel) || 'null');
      if (b && Date.now() - b.t < 60000) return Promise.resolve(b.d);
    } catch (e) {}
    return fetch(ADRES + '?land=' + land).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
      try { if (d) sessionStorage.setItem(sleutel, JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
      return d;
    });
  }
  haal().then(function (data) {
    if (!data) return;
    vul(data, taal);
    // Later toegevoegde productkaarten (filteren, "toon meer", quick shop).
    if (window.MutationObserver) new MutationObserver(function (m) {
      m.forEach(function (x) { x.addedNodes.forEach(function (n) { if (n.nodeType === 1) vul(data, taal, n); }); });
    }).observe(document.body, { childList: true, subtree: true });
  }).catch(function () {});
})();
